<template>
  <div class="profile">
    <personel-profile-section :args="args" />
    <announcements-section class="mt-2" />
    <messages-section :args="args" class="mt-2" />
    <box
      v-if="btnResetPasswordVisible || btnEditpermissionVisible"
      class="mt-2"
      :title="$t('adminSettings')"
    >
      <div class="pa-3">
        <v-btn
          v-if="btnResetPasswordVisible"
          @click="ResetPassword"
          color="primary"
          class="mx-1"
          >{{ $t("ResetPassword") }}</v-btn
        >
        <v-btn
          v-if="btnEditpermissionVisible"
          @click="EditPermission"
          color="primary"
          class="mx-1"
          >{{ $t("EditPermission") }}</v-btn
        >
        <div class="d-flex mt-2 mx-1">
          <v-text-field
            v-model="txtDomainLoginName"
            hide-details=""
            solo
            dense
            :label="$t('SaveDomainLoginName')"
          ></v-text-field>
          <v-btn @click="SaveDomainLoginName" color="primary" class="mx-1">{{
            $t("SaveDomainLoginName")
          }}</v-btn>
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import PersonelProfileSection from "../../components/profile/PersonelProfileSection.vue";
import AnnouncementsSection from "../../components/profile/AnnouncementsSection.vue";
import MessagesSection from "../../components/profile/MessagesSection.vue";
import EosUtils from "../../utils/EosUtils";
import ResultType from "../../model/ResultType";
import EosToastType from "../../model/EosToastType";
export default {
  components: {
    PersonelProfileSection,
    AnnouncementsSection,
    MessagesSection,
  },
  data() {
    return {
      args: null,
      btnEditpermissionVisible: false,
      btnResetPasswordVisible: false,
      txtDomainLoginName: "",
    };
  },
  mounted() {
    ////debugger
    if (this.$route.query) {
      this.args = this.$route.query;
      // var aa =this.args.paid
      // console.log('wwwwww:'+aa)
    }
  },
  watch: {
    args(newVal) {
      console.log(newVal);
      if (newVal != {}) {
        this.pageLoad();
      }
    },
  },
  methods: {
    pageLoad() {
      ////debugger
      this.SetExpireAlarm();
      if (EosUtils.isWebKartAdmin()) {
        this.btnEditpermissionVisible = true;
        this.$store.dispatch("IsActvieSecurity").then((result) => {
          if (result.type === ResultType.success) {
            this.btnResetPasswordVisible = !result.data;
          }
        });
        this.FillDomainName();
        ////debugger;
        console.log("personelAdmin")
          let personel = this.$store.state.personel.personelDetail;
          console.log(personel)
      } else {
        var activeDirectory=localStorage.getItem('userActive')
        if (this.args && this.args.pid || activeDirectory) {
          
         
          ////debugger
          // var perno = this.args.pid;
          var perno = this.$store.state.auth.auth.username;
          //debugger
          this.args.paid=perno;
          this.$route.query.paid=perno;
          
         
          // if(activeDirectory){
          //   var username=activeDirectory
          //   this.$store
          //   .dispatch("GetPernoOfUsername",{username})
          //   .then((result) => {
          //     //debugger
          //     if (result.type === ResultType.success) {
                
          //       perno= result.data;
          //     }
          //     else if(result.type===ResultType.error && result.response!=''){
          //       perno= result.response;
          //       this.args.paid=perno;
          //       this.$route.query.paid=perno;
          //       var aa= this.args.paid;
          //       var bb= this.$route.query.paid;
          //       console.log('aa: '+aa+'bb: '+bb)

          //     }
          //   })
          //#######

            
          // }
          // if( activeDirectory){

          // }
          // else{
          //   var section = this.args.section;
          // }

          var section = this.args.section;
          this.$store
            .dispatch("sections/CanChangePersonPermission", { perno, section })
            .then((result) => {
              if (result.type === ResultType.success) {
                this.btnEditpermissionVisible = result.data;
              }
            });

          var promises = [];
          promises.push(
            this.$store.dispatch("sections/CanResetPersonPassword", {
              perno, 
              section,
            })
          );
          promises.push(this.$store.dispatch("IsActvieSecurity"));
          Promise.all(promises)
            .then((result) => {
              //console.log(result);
              var pass = false;
              if (result[0].type === "success") {
                pass = result[0].data;
              }
              if (result[1].type === "success") {
                if (result[1].data) {
                  this.btnResetPasswordVisible = false;
                } else {
                  this.btnResetPasswordVisible = pass;
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });

          this.FillDomainName();
         
          this.args.paid=perno;
          this.$route.query.paid=perno;
          ////debugger;
          // console.log("personelAdmino")
          // let personel = this.$store.state.personel.personelDetail;
          // console.log(personel)
          ////debugger
          if (this.args.ch == "1") {
            let management = this.$store.state.personel.personelDetail
            var result = localStorage.getItem('manage');
            const existLastManage = JSON.parse(result);
            if (!existLastManage) {
              if (management) {
                localStorage.setItem("manage", JSON.stringify(management))
                const retrievedObject = localStorage.getItem('manage');

                console.log('retrievedObject: ', JSON.parse(retrievedObject));
                this.$store.state.personel.personelDetail = management;

                var params2 = {
                  pid: perno,
                  section: section,
                  ch: "0"

                };
                this.$router.push({ name: "profile", query: params2 });
                params2.pid = "";
                params2.section = "";
                // var getPid=localStorage.getItem('pidSetPass');
                // this.args.pid=getPid;
                ////debugger

              }

            }





          } else {
            ////debugger
            var getPid = localStorage.getItem('pidSetPass');
            this.args.pid = getPid;

          }
          ////debugger
          
          

          

        ////debugger
        
        // this.$router.push({ name: "profile", query: params2 });
          
         
        } else {
          this.btnEditpermissionVisible = false;
          this.btnResetPasswordVisible = false;
        }
      }
    },
    SetExpireAlarm() {
      var perno = "";
      if (this.args && this.args.pid) {
        perno = this.args.pid;
      } else {
        perno = this.$store.state.auth.auth.username;
      }

      this.$store.dispatch("GetAlarmExpire", { perno }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success && result.data) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.data,
          });
        }
      });
    },
    FillDomainName() {
      
      ////debugger
      var perno = this.args.pid;
      this.$store.dispatch("FindUserDomainName", { perno }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.txtDomainLoginName = result.data;
        }
      });
    },
    ResetPassword() {
      if (this.args && this.args.pid) {
        var perno = this.args.pid;
        var params = {
          password: perno,
          perno: perno,
        };

        this.$store.dispatch("ChangePassword", { params }).then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
          }
        });
      }
    },
    EditPermission() {
      //debugger
      var query = {
        pid: this.args.pid,
      };
      if (EosUtils.isWebKartAdmin()) {
        this.$router.push({ name: "publicAccess", query: query });
      }
      else{
        this.$router.push({ name: "accessPublic", query: query });
      }

      
    },
    SaveDomainLoginName() {
      console.log(this.txtDomainLoginName);
      if (this.args && this.args.pid && this.txtDomainLoginName) {
        var perno = this.args.pid;
        var UpdateDomainUserNameParams = {
          domainUsername: this.txtDomainLoginName,
          perno: perno,
        };

        this.$store
          .dispatch("UpdateDomainUserName", { UpdateDomainUserNameParams })
          .then((result) => {
            if (result.type === ResultType.success && result.data) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
          }
          });
      }
    },
  },
};
</script>

<style >
.title {
  color: var(--color-accent);
}
.value {
  color: var(--border-green) !important;
}
</style>